export const blockIconsHouseholdWeekendNew = (
	<span className='material-symbols-outlined'>weekend</span>
);
